import React from "react";
import { Container } from "./styles";
import "animate.css";
import Header from "../../components/HeaderOxeTechWork";
import Inscrevase from "./Inscrevase";
import Rodape from "../../components/Rodape";
import Logo2 from "../../assets/LOGO_OXETECH_WORK.png";
import { useState } from "react";
import "./style.css";

import { createTheme, ThemeProvider } from "@mui/material/styles";
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 800,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

function Main() {
  const [etapaSelecionada, setEtapaSelecionada] = useState();

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <Header />
        <div className="bodyWork">
          <div className="logoContainer">
            <img
              src={Logo2}
              alt="Logo"
              style={{
                width: "37%",

                height: "20%",
                marginTop: "20px",
              }}
            />
            <p>
              <strong>Encontre e oferte oportunidades de trabalho!</strong>
            </p>
          </div>

          <div className="cardContainerWork">
            <div className="card">
              <div className="cardTitle">
                <h1>Sobre o programa</h1>
              </div>
              <div className="barrinha"></div>
              <div className="cardDescription">
                <h2>
                  <strong>
                    O OxeTech Work é uma iniciativa da Secretaria de Ciência,
                    Tecnologia e Inovação de Alagoas (SECTI)
                  </strong>{" "}
                  que conecta capacitação técnica à inserção no mercado de
                  trabalho, gerando empregos, renda e impulsionando a economia
                  digital no estado. Através de polos de ensino a distância, o
                  programa oferece formação em tecnologia e áreas afins,
                  aproximando estudantes, empresas e profissionais. Em dois
                  meses, mais de{" "}
                  <strong>
                    1.400 alunos foram beneficiados, reforçando o potencial de
                    Alagoas como referência em inovação e qualificação
                    profissional.
                  </strong>
                </h2>
              </div>
            </div>
            <div className="card2">
              <div>
                <h1 className="cardTitle2">Etapas</h1>
              </div>
              <div className="barrinha2"></div>

              <div className="setas">
                <div className="setaContainer">
                  <div className="seta1"></div>
                  <button
                    className="cardButton"
                    style={{ backgroundColor: "#1e3a8a" }}
                    onClick={() =>
                      setEtapaSelecionada({
                        titulo: "Inscrição na plataforma",
                        descricao: [
                          <p>
                            📅 As inscrições para o programa{" "}
                            <strong>OxeTech Work</strong> começam no dia{" "}
                            <strong>28 de abril de 2025</strong>. Tudo é feito
                            online — basta se cadastrar na{" "}
                            <strong>Plataforma OxeTech</strong> para começar.
                          </p>,
                          <p>
                            🏢{" "}
                            <strong>
                              Podem participar empresas e também pessoas
                              físicas,
                            </strong>
                            como estudantes e profissionais, desde que estejam
                            inscritos na{" "}
                            <strong>Plataforma OxeTech Work.</strong> As
                            empresas devem ser Empresas de Base Tecnológica, de
                            Economia Criativa (com foco em audiovisual, design,
                            games e produção cultural) ou desenvolver projetos
                            com tecnologia inovadora ou conhecimento
                            técnico-científico.
                          </p>,
                          <p>
                            💡 Mesmo que sua proposta não esteja nas áreas
                            padrão, você pode participar se aplicar tecnologia
                            inovadora. Envie uma justificativa simples
                            explicando sua ideia e a possibilidade de
                            contratação após o programa.
                          </p>,
                        ],
                      })
                    }
                  >
                    <strong>1</strong>
                  </button>
                  <h2 className="">Inscrição na plataforma</h2>
                </div>
                <div className="setaContainer">
                  <div className="seta2"></div>
                  <button
                    className="cardButton"
                    style={{ backgroundColor: "#3b82f6" }}
                    onClick={() =>
                      setEtapaSelecionada({
                        titulo: "Análise de perfil",
                        descricao: [
                          <p>
                            🔍 As propostas enviadas pelas empresas, para
                            divulgação das vagas e contratação de bolsistas via
                            OxeTech Work, devem estar relacionadas a pelo menos
                            uma das seguintes áreas:
                            <p> Ciência de Dados.</p>{" "}
                            <p>Inteligência Artificial. </p>{" "}
                            <p> Internet das Coisas (IoT).</p>{" "}
                            <p> Machine Learning.</p>{" "}
                            <p> Análise Estatística de Dados. </p>{" "}
                            <p>
                              Desenvolvimento de Sistemas Web (em qualquer
                              linguagem).{" "}
                            </p>{" "}
                            <p> Redes e Infraestrutura de Redes. </p>
                            Economia Criativa com foco em novas tecnologias,
                            especialmente em setores como audiovisual, design,
                            games e produção cultural, voltada para arte digital
                            em suas diversas formas.
                          </p>,
                        ],
                        cor: "#2557a3",
                      })
                    }
                  >
                    <strong>2</strong>
                  </button>
                  <h2>Análise de perfil da empresa e publicação de vagas</h2>
                </div>
                <div className="setaContainer">
                  <div className="seta3"></div>
                  <button
                    className="cardButton"
                    style={{ backgroundColor: "#60a5fa" }}
                    onClick={() =>
                      setEtapaSelecionada({
                        titulo: "Seleção dos candidatos",
                        descricao: [
                          <p>
                            ✅ Etapa de Seleção de Candidatos Para participar do
                            programa, cada empresa deverá, no momento do
                            credenciamento, apresentar:{" "}
                            <p>
                              A <strong>descrição da vaga</strong> que será
                              publicada na plataforma,
                            </p>{" "}
                            <p>
                              {" "}
                              O <strong>plano de trabalho</strong> ou{" "}
                              <strong> proposta de inovação</strong> que será
                              desenvolvida pelo bolsista,
                            </p>{" "}
                            <p>
                              {" "}
                              E a{" "}
                              <strong>
                                comprovação de capacidade financeira{" "}
                              </strong>{" "}
                              para manter o bolsista por até{" "}
                              <strong>
                                12 meses após o término do projeto.
                              </strong>
                            </p>
                          </p>,
                          <p>
                            ⚠️ A comprovação de que a empresa é uma{" "}
                            <strong>Empresa de Base Tecnológica (EBT)</strong>{" "}
                            ou atua na área de{" "}
                            <strong>Economia Criativa</strong> é{" "}
                            <strong>obrigatória</strong> e de caráter{" "}
                            <strong>eliminatório.</strong>{" "}
                            <p>
                              No entanto, empresas de outros segmentos também
                              podem participar, desde que apresentem uma
                              justificativa por escrito, comprovando:{" "}
                              <p>
                                Que possuem um produto, serviço ou projeto com
                                aplicação de tecnologia inovadora ou
                                conhecimento técnico-científico,
                              </p>
                              <p>
                                E que têm condições de manter o aluno-bolsista
                                pelos 12 meses seguintes ao programa.
                              </p>
                            </p>
                          </p>,
                        ],
                        cor: "#346db8",
                      })
                    }
                  >
                    <strong>3</strong>
                  </button>
                  <h2>Seleção dos candidatos</h2>
                </div>
                <div className="setaContainer">
                  <div className="seta4"></div>
                  <button
                    className="cardButton"
                    style={{ backgroundColor: "#93c5fd" }}
                    onClick={() =>
                      setEtapaSelecionada({
                        titulo: "Bolsa + contrato",
                        descricao: [
                          <p>
                            💼 Ao todo, serão oferecidas até 200 bolsas, no
                            valor de R$ 1.500,00 por mês, com duração de 6
                            meses. Essas bolsas serão destinadas a
                            candidatos(as) inscritos(as) na Plataforma OxeTech
                            Work, que forem selecionados para vagas publicadas
                            por empresas habilitadas no programa.
                          </p>,
                        ],
                        cor: "#5a8dcf",
                      })
                    }
                  >
                    <strong>4</strong>
                  </button>
                  <h2>Bolsa de 6 meses + contrato de trabalho de 12 meses</h2>
                </div>
                {etapaSelecionada && (
                  <div
                    className="modalOverlay"
                    onClick={() => setEtapaSelecionada(null)}
                  >
                    <div
                      className="modalContent"
                      onClick={(e) => e.stopPropagation()}
                      style={{ backgroundColor: etapaSelecionada.cor }}
                    >
                      <button
                        className="fecharModal"
                        onClick={() => setEtapaSelecionada(null)}
                      >
                        X
                      </button>
                      <h2>{etapaSelecionada.titulo}</h2>
                      <p>&nbsp;&nbsp;&nbsp;</p>
                      {/* Renderiza a lista de tópicos */}
                      {etapaSelecionada.descricao &&
                        etapaSelecionada.descricao.length > 0 && (
                          <ul>
                            {etapaSelecionada.descricao.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="card3">
              <div className="cardTitle3">
                <h1>Inscreva-se no OxeTech Work!</h1>
              </div>
              <div className="barrinha3"></div>
              <Inscrevase />
            </div>
            <div className="card4">
              <div className="cardTitle4">
                <h1>Quer saber mais?</h1>
              </div>
              <div className="barrinha4"></div>
              <div className="cardDescription">
                <h2>
                  O <strong>OxeTech Work</strong> é uma política pública
                  idealizada pela Secretaria de Estado da Ciência, da Tecnologia
                  e da Inovação de Alagoas (SECTI), com o objetivo de fomentar a
                  economia alagoana por meio da integração direta entre
                  capacitação técnica e inserção no mercado de trabalho
                  tecnológico e inovador. O programa busca qualificar alunos,
                  gerar empregos, transferir renda e estimular o desenvolvimento
                  social, preparando a população para os desafios e
                  oportunidades da nova economia digital. Alagoas e seus
                  municípios vêm demonstrando um expressivo potencial de
                  crescimento, especialmente no setor de tecnologia e inovação.
                  Diante desse cenário, o OxeTech Work surge como uma resposta
                  concreta, oferecendo formações em tecnologia da informação e
                  áreas afins por meio de uma rede de polos de ensino a
                  distância. O programa promove a aproximação entre estudantes,
                  empresas, professores e profissionais, criando um verdadeiro
                  intercâmbio de conhecimento e oportunidade. Em apenas dois
                  meses, mais de 1.400 alunos foram impactados, fortalecendo o
                  ecossistema local e consolidando o estado como um polo
                  emergente de inovação e capacitação profissional.
                </h2>
                <div className="cardBeneficios2">
                  <div
                    className="cardDescription4"
                    style={{
                      background: "linear-gradient(135deg, #2f80ed, #1e3a8a)",
                    }}
                  >
                    <h1>Empresa de base tecnológica</h1>
                    <h2>
                      Empresas que estão comprometidas com projeto de
                      desenvolvimento e produção de novos produtos e/ou
                      processos, caracterizando-se pela aplicação sistemática de
                      conhecimento técnico-científico e uso de tecnologias
                      inovadoras.
                    </h2>
                  </div>
                  <div
                    className="cardDescription4"
                    style={{ background: "#3474dc" }}
                  >
                    <h1>Empresa de Economia Criativa</h1>
                    <h2>
                      Empresas que adotam modelos de negócio ou gestão que se
                      originam em atividades, produtos ou serviços desenvolvidos
                      a partir do conhecimento, criatividade ou capital
                      intelectual de indivíduos.
                    </h2>
                  </div>
                  <div
                    className="cardDescription4"
                    style={{
                      background: "linear-gradient(135deg, #1e3a8a, #3b5998)",
                    }}
                  >
                    <h1>Tecnologia Inovadora</h1>
                    <h2 style={{ fontSize: "16px" }}>
                      Aplicação de tecnologia que representa novidade ou
                      aperfeiçoamento no ambiente produtivo e social, que
                      resulte em novos produtos, serviços ou processos ou que
                      agregue novas funcionalidades ou características a
                      produto, serviço ou processo já existente, desde que tal
                      adição resulte em melhorias e/ou em ganho de
                      qualidade/desempenho.
                    </h2>
                  </div>
                </div>
                <div className="Button-Container3">
                  <button
                    className="cardButton2"
                    onClick={() => window.open("/edital2025.pdf", "_blank")}
                  >
                    Acesse o edital completo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Rodape />
      </Container>
    </ThemeProvider>
  );
}

export default Main;
